import * as R from 'ramda'

export default (reasons) => R.append({ id: 'ER', name: 'Guardia' }, reasons)
